// src/components/Registrarme/Registrarme.js
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Registrarme.css";
import registraHombre from "../../assets/generales/conectapersona.svg";
import conectaLogo from "../../assets/generales/conecta-peru-footer.svg";

import CustomModal from "../../components/CustomModal/CustomModal";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Registrarme = () => {
  const navigate = useNavigate();

  // Estados del formulario de registro
  const [nombres, setNombres] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [email, setEmail] = useState("");
  const [contrasenia, setContrasenia] = useState("");
  const [numeroContacto, setNumeroContacto] = useState("");
  const [ubigeo, setUbigeo] = useState("");
  const [isAdult, setIsAdult] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);

  // Estados para el modal de términos y condiciones
  const [showTerms, setShowTerms] = useState(false);

  // Estados para el autocompletado de ubigeos
  const [allUbigeos, setAllUbigeos] = useState([]); // NUEVO: Para almacenar todos los ubigeos de la API
  const [loadingUbigeos, setLoadingUbigeos] = useState(true); // NUEVO: Estado de carga para ubigeos
  const [errorUbigeos, setErrorUbigeos] = useState(null); // NUEVO: Estado para errores de ubigeos
  const [filteredUbigeos, setFilteredUbigeos] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  // Estados para el nuevo flujo de verificación de correo
  const [showVerificationBlock, setShowVerificationBlock] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [registeredEmail, setRegisteredEmail] = useState("");
  const [registeredUserId, setRegisteredUserId] = useState(null);

  // Estado para controlar el tiempo de espera antes de poder reenviar el código
  const [resendCooldown, setResendCooldown] = useState(0);
  const [resendIntervalId, setResendIntervalId] = useState(null);

  // NUEVOS ESTADOS DE LOADING PARA LOS BOTONES
  const [isRegistering, setIsRegistering] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isResending, setIsResending] = useState(false);

  // Estados para el CustomModal (reutilizable)
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    message: "",
    type: "",
  });

  const openModal = (title, message, type = "info") => {
    setModalContent({ title, message, type });
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    if (
      modalContent.type === "success" &&
      modalContent.title === "Verificación Exitosa"
    ) {
      navigate("/login");
    }
  };

  // NUEVO: useEffect para cargar los ubigeos al montar el componente
  useEffect(() => {
    const fetchUbigeos = async () => {
      setLoadingUbigeos(true);
      setErrorUbigeos(null);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/usuarios/list-ubigeo`
        );
        // Asumiendo que la API devuelve un array de objetos con 'cod' y 'nom'
        if (response.data && Array.isArray(response.data)) {
          setAllUbigeos(response.data);
        } else {
          setErrorUbigeos("Formato de datos de ubigeos inesperado.");
          console.error("Formato de datos de ubigeos inesperado:");
        }
      } catch (error) {
        console.error("Error al cargar ubigeos:", error);
        setErrorUbigeos("No se pudo cargar la lista de ubigeos.");
      } finally {
        setLoadingUbigeos(false);
      }
    };

    fetchUbigeos();
  }, []); // El array vacío asegura que se ejecute solo una vez al montar

  const isRegistrationFormValid =
    nombres.trim().length >= 3 &&
    apellidos.trim().length >= 4 &&
    email.trim() !== "" &&
    contrasenia.trim().length >= 6 &&
    numeroContacto.trim().length >= 7 &&
    ubigeo.trim() !== "" &&
    isAdult &&
    acceptTerms;

  const isVerificationCodeValid = /^\d{4}$/.test(verificationCode);

  const handleUbigeoChange = (e) => {
    const value = e.target.value;
    setUbigeo(value);

    if (value.length > 0) {
      const filtered = allUbigeos.filter((item) =>
        item.nom.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredUbigeos(filtered);
      setShowDropdown(true);
    } else {
      setFilteredUbigeos([]);
      setShowDropdown(false);
    }
  };

  const handleSelectUbigeo = (item) => {
    setUbigeo(item.nom);
    setShowDropdown(false);
  };

  const startResendCooldown = (duration = 180) => {
    setResendCooldown(duration);
    if (resendIntervalId) {
      clearInterval(resendIntervalId);
    }
    const id = setInterval(() => {
      setResendCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(id);
          setResendIntervalId(null);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    setResendIntervalId(id);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isRegistrationFormValid) {
      openModal(
        "Error de Formulario",
        "Por favor, completa todos los campos obligatorios y acepta las condiciones.",
        "error"
      );
      return;
    }

    if (!/^\d{7,9}$/.test(numeroContacto.trim())) {
      // Asumiendo mínimo 7, máximo 9
      openModal(
        "Error de Contacto",
        "El número de contacto debe contener solo dígitos y tener entre 7 y 9 caracteres.",
        "error"
      );
      return;
    }

    const selectedUbigeo = allUbigeos.find((item) => item.nom === ubigeo);
    const idUbigeo = selectedUbigeo ? selectedUbigeo.cod : null;

    if (!idUbigeo) {
      openModal(
        "Error de Ubigeo",
        "Por favor, selecciona un ubigeo válido de la lista sugerida.",
        "error"
      );
      return;
    }

    setIsRegistering(true); // INICIA LOADING
    try {
      const response = await axios.post(`${API_BASE_URL}/usuarios/register`, {
        nombres: nombres,
        apellidos: apellidos,
        correo: email,
        contrasenia: contrasenia,
        numerocontacto: numeroContacto,
        mayoredad: isAdult ? 1 : 0,
        aceptapolitica: acceptTerms ? 1 : 0,
        idubigeo: idUbigeo,
      });

      if (response.status === 201) {
        openModal(
          "Registro Exitoso",
          response.data.message ||
            "Usuario registrado. Por favor, revisa tu correo para verificar tu cuenta.",
          "success"
        );
        setRegisteredEmail(email);
        setRegisteredUserId(response.data.userId);
        setShowVerificationBlock(true);
        startResendCooldown();
      }
    } catch (error) {
      console.error("Error al registrar usuario:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ocurrió un error al intentar registrarte. Inténtalo de nuevo.";
      openModal("Error de Registro", errorMessage, "error");
    } finally {
      setIsRegistering(false); // TERMINA LOADING (éxito o error)
    }
  };

  const handleVerifyCode = async () => {
    if (!isVerificationCodeValid) {
      openModal(
        "Código Inválido",
        "Por favor, ingresa un código de verificación válido (4 dígitos numéricos).",
        "error"
      );
      return;
    }
    if (!registeredEmail || registeredUserId === null) {
      openModal(
        "Error",
        "No se pudo obtener la información de registro. Intenta registrarte de nuevo.",
        "error"
      );
      return;
    }

    setIsVerifying(true); // INICIA LOADING
    try {
      const response = await axios.post(
        `${API_BASE_URL}/usuarios/verify-email`,
        {
          correo: registeredEmail,
          codigo: verificationCode,
          idusuario: registeredUserId,
        }
      );

      if (response.status === 200) {
        openModal(
          "Verificación Exitosa",
          response.data.message ||
            "Tu correo ha sido verificado. ¡Ya puedes iniciar sesión!",
          "success"
        );
      }
    } catch (error) {
      console.error("Error al verificar correo:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Ocurrió un error al verificar el código. Por favor, revisa el código e inténtalo de nuevo.";
      openModal("Error de Verificación", errorMessage, "error");
    } finally {
      setIsVerifying(false); // TERMINA LOADING (éxito o error)
    }
  };

  const handleResendCode = async () => {
    if (resendCooldown > 0) {
      openModal(
        "Espera",
        `Debes esperar ${resendCooldown} segundos antes de reenviar el código.`,
        "info"
      );
      return;
    }

    if (!registeredEmail || registeredUserId === null) {
      openModal(
        "Error",
        "No se pudo obtener la información de registro para reenviar el código.",
        "error"
      );
      return;
    }

    setIsResending(true); // INICIA LOADING
    try {
      const response = await axios.post(
        `${API_BASE_URL}/usuarios/request-verification-email`,
        {
          correo: registeredEmail,
          idusuario: registeredUserId,
        }
      );

      if (response.status === 200) {
        openModal(
          "Código Reenviado",
          response.data.message ||
            "Un nuevo código de verificación ha sido enviado a tu correo.",
          "success"
        );
        setVerificationCode("");
        startResendCooldown();
      }
    } catch (error) {
      console.error("Error al reenviar código:", error);
      const errorMessage =
        error.response?.data?.message ||
        "No se pudo reenviar el código. Inténtalo de nuevo más tarde.";
      openModal("Error al Reenviar", errorMessage, "error");
    } finally {
      setIsResending(false); // TERMINA LOADING (éxito o error)
    }
  };

  return (
    <div className="login-root row g-0 min-vh-100">
      <div className="col-md-6 d-none d-md-block login-img-col p-0">
        <img
          src={registraHombre}
          alt="Registro ilustración"
          className="login-img w-100 h-100"
        />
      </div>
      <div className="col-12 col-md-6 d-flex align-items-center justify-content-center login-form-bg">
        <div className="login-form-box w-100">
          <div className="text-center mb-4">
            <img
              src={conectaLogo}
              alt="Conéctate Perú"
              className="login-title-img mb-3"
            />
            <h2 className="login-heading mb-4">Regístrate</h2>
          </div>

          {!showVerificationBlock ? (
            <form onSubmit={handleSubmit}>
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="floatingNombres"
                  placeholder="Nombres"
                  value={nombres}
                  onChange={(e) => setNombres(e.target.value)}
                  required
                />
                <label htmlFor="floatingNombres">Nombres</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="floatingApellidos"
                  placeholder="Apellidos"
                  value={apellidos}
                  onChange={(e) => setApellidos(e.target.value)}
                  required
                />
                <label htmlFor="floatingApellidos">Apellidos</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="floatingCorreo"
                  placeholder="Correo"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label htmlFor="floatingCorreo">Correo</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="text" // Se mantiene como 'text' para mayor flexibilidad
                  className="form-control"
                  id="floatingNumeroContacto"
                  placeholder="Número de Contacto"
                  value={numeroContacto}
                  onChange={(e) => {
                    // FILTRAR SOLO DÍGITOS Y LIMITAR LONGITUD
                    const value = e.target.value;
                    const filteredValue = value.replace(/\D/g, ""); // Elimina todo lo que no sea dígito
                    if (filteredValue.length <= 9) {
                      // Limita a 9 dígitos
                      setNumeroContacto(filteredValue);
                    }
                  }}
                  maxLength="9" // Atributo HTML para limitar la entrada visualmente
                  inputMode="numeric" // Sugiere teclado numérico en dispositivos móviles
                  pattern="\d{7,9}" // Para validación básica del navegador (7 a 9 dígitos)
                  title="Ingresa un número de contacto válido (7 a 9 dígitos)" // Mensaje tooltip
                  required
                />
                <label htmlFor="floatingNumeroContacto">
                  Número de Contacto
                </label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="password"
                  className="form-control"
                  id="floatingContrasenia"
                  placeholder="Crear Contraseña"
                  autoComplete="new-password"
                  value={contrasenia}
                  onChange={(e) => setContrasenia(e.target.value)}
                  required
                />
                <label htmlFor="floatingContrasenia">Crear Contraseña</label>
              </div>

              <div className="form-floating mb-3 position-relative">
                <input
                  type="text"
                  className="form-control"
                  id="floatingUbigeo"
                  placeholder="Ubigeo (Dep./Prov./Dist.)"
                  value={ubigeo}
                  onChange={handleUbigeoChange}
                  autoComplete="off"
                  // Deshabilita el input mientras los ubigeos están cargando
                  disabled={loadingUbigeos}
                  onFocus={() => ubigeo.length > 0 && setShowDropdown(true)}
                  onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
                  required
                />
                <label htmlFor="floatingUbigeo">
                  {loadingUbigeos
                    ? "Cargando Ubigeos..."
                    : errorUbigeos
                    ? "Error al cargar Ubigeos"
                    : "Ubigeo (Dep./Prov./Dist.)"}
                </label>

                {showDropdown && filteredUbigeos.length > 0 && (
                  <ul
                    className="dropdown-list list-group position-absolute w-100 shadow-sm bg-white"
                    style={{
                      zIndex: 1000,
                      maxHeight: "150px",
                      overflowY: "auto",
                    }}
                  >
                    {filteredUbigeos.map((item) => {
                      const searchText = ubigeo.trim().toLowerCase();
                      const itemText = item.nom.toLowerCase();
                      const startIndex = itemText.indexOf(searchText);

                      if (startIndex === -1) {
                        return (
                          <li
                            key={item.cod}
                            className="list-group-item list-group-item-action"
                            onMouseDown={() => handleSelectUbigeo(item)}
                            style={{ cursor: "pointer" }}
                          >
                            {item.nom}
                          </li>
                        );
                      }

                      const endIndex = startIndex + searchText.length;

                      return (
                        <li
                          key={item.cod}
                          className="list-group-item list-group-item-action"
                          onMouseDown={() => handleSelectUbigeo(item)}
                          style={{ cursor: "pointer" }}
                        >
                          {item.nom.substring(0, startIndex)}
                          <strong>
                            {item.nom.substring(startIndex, endIndex)}
                          </strong>
                          {item.nom.substring(endIndex)}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>

              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="mayorEdad"
                  checked={isAdult}
                  onChange={() => setIsAdult(!isAdult)}
                  required
                />
                <label className="form-check-label" htmlFor="mayorEdad">
                  Soy mayor de edad
                </label>
              </div>

              <div className="form-check mb-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="aceptaTerminos"
                  checked={acceptTerms}
                  onChange={() => setAcceptTerms(!acceptTerms)}
                  required
                />
                <label className="form-check-label" htmlFor="aceptaTerminos">
                  Acepto los{" "}
                  <button
                    type="button"
                    className="btn btn-link p-0 align-baseline"
                    onClick={() => setShowTerms(true)}
                  >
                    términos y condiciones
                  </button>
                </label>
              </div>

              <div className="d-grid mb-3">
                <button
                  type="submit"
                  className="btn-login-aceptar"
                  disabled={!isRegistrationFormValid || isRegistering}
                >
                  {isRegistering ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {" Registrando..."}
                    </>
                  ) : (
                    "Registrarme"
                  )}
                </button>
              </div>

              <div className="text-center">
                <Link to="/login" className="login-link-register">
                  Iniciar sesión
                </Link>
              </div>
            </form>
          ) : (
            <div className="verification-block">
              <p className="text-center mb-4">
                Se ha enviado un código de verificación a{" "}
                <strong>{registeredEmail}</strong>. Por favor, ingrésalo a
                continuación para activar tu cuenta.
              </p>
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="floatingVerificationCode"
                  placeholder="Código de Verificación"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  maxLength="4"
                  pattern="\d{4}"
                  inputMode="numeric"
                  required
                />
                <label htmlFor="floatingVerificationCode">
                  Código de Verificación
                </label>
              </div>
              <div className="d-grid mb-3">
                <button
                  type="button"
                  className="btn-login-aceptar"
                  onClick={handleVerifyCode}
                  disabled={!isVerificationCodeValid || isVerifying}
                >
                  {isVerifying ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {" Verificando..."}
                    </>
                  ) : (
                    "Validar Código"
                  )}
                </button>
              </div>
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-link p-0 align-baseline"
                  onClick={handleResendCode}
                  disabled={resendCooldown > 0 || isResending}
                >
                  {isResending ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {" Reenviando..."}
                    </>
                  ) : (
                    `Reenviar Código${
                      resendCooldown > 0 ? ` (${resendCooldown}s)` : ""
                    }`
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {showTerms && (
        <div className="modal-backdrop">
          <div className="modal-content-terms">
            <h5>Términos y Condiciones</h5>
            <div className="modal-body-terms">
              <p>
                Aquí van los términos y condiciones completos que el usuario
                debe aceptar para registrarse.
              </p>
            </div>
            <button
              className="btn btn-primary mt-3"
              onClick={() => setShowTerms(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

      <CustomModal
        isOpen={modalIsOpen}
        title={modalContent.title}
        message={modalContent.message}
        type={modalContent.type}
        onClose={closeModal}
      />
    </div>
  );
};

export default Registrarme;
